import React from 'react';

export const CoffeeCompleteMessage = () => (
  <strong>Your coffee will now be roasted and shipped, straight from one of our partner roasters to you!</strong>
);
